import React, { useState } from "react";
import styles from "../../styles/HomePage.module.css";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className={styles.header}>
      <div className={`${styles.container} ${styles.headerContainer}`}>
        <a href="#" className={styles.logo}>
          Cars<span>24</span>
        </a>
        <nav className={`${styles.navMenu} ${menuOpen ? styles.active : ""}`}>
          <a href="#">Buy Used Cars</a>
          <a href="#">Sell Car</a>
          <a href="#">Finance</a>
          <a href="#">Services</a>
          <a href="#">About Us</a>
        </nav>
        <div className={styles.headerRight}>
          <Link className={styles.btn} to={"/user-login"}>
            Login
          </Link>
          <button
            className={styles.mobileMenuBtn}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <FaBars />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
